import {
    React,
    useState,
    useActionUrl,
    Form,
    PageHeader,
    useFormInit,
    useLocation,
    CompanyRoutes,
    queryString,
    $,
    useEffect,
    showUserMessageHTML, urlConfigs,
} from 'library/base/baseContainerImports'

import GlobalStyles from "../../moduleComponents/formDesigner/GlobalStyles";
import LiveViewStyles from "../../moduleComponents/formDesigner/LiveView.css";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import SquareForm from '../PaymentMethod/Square/SquareForm';
import { PaymentMethods } from "constants/paymentMethods";


const Container = () => {

    const location = useLocation();
    const {id,authhash,student_id} = queryString.parse(location.search);
    let isInitLoad = true;

    const {getFormActions} = useActionUrl();
    const {formAction, formDefinitionAction} = getFormActions(null,{id:id, authhash:authhash, student_id});
    const [stripePublicKey, setStripePublicKey] = useState('');
    const [clientSecret, setClientSecret] = useState('');

    const {getFullUrl}      = useActionUrl();
    const settingsModule    = CompanyRoutes.ADMIN.COMPANY_SIGNUP.SETTINGS;
    const settingAction     = getFullUrl(settingsModule.path, {authhash:authhash,load:'data'});

    const signupModule   = CompanyRoutes.ADMIN.COMPANY_SIGNUP;
    
    const [companyLogo, setCompanyLogo] = useState('');

    const companyBranding = () => {
        const formAction    = urlConfigs.BASE_URL + '/rest/acl?authhash=' + authhash;
        $.get(formAction, function (data){
            if (data?.meta?.logo) {
                setCompanyLogo(data.meta.logo);
                $(".company-logo").removeClass('hide');
            }
        });
    };

    const announceHeight = () => {
        let message = {
            height: document.getElementsByClassName('bg-white')[0].clientHeight + 300
        };
        window.parent.postMessage(message, "*");
    };
    const announceScroll = () => {
        let message = {
            scroll: 1
        };
        window.parent.postMessage(message, "*");
    };

    const paymentTermsSlide = () => {
        $(".payment-terms").click(function (){
            $(".payment-terms-details").slideToggle(400, function (){
                announceHeight();
            });
            return false;
        });
    };

    const waiverSlide = () => {
        $(".waiver-toggler").click(function (){
            $(".waiver-details").slideToggle(400, function (){
                announceHeight();
            });
            return false;
        });
    };

    const updateCart = () => {
        let couponCode = "";
        if ($("input[id*='coupon']").length) {
            couponCode = $("input[id*='coupon']").val();
        }

        let creditCardNumber = "";
        if ($("input[id*='card_number']").length) {
            creditCardNumber = $("input[id*='card_number']").val();
        }

        let firstName = "";
        if ($("input[id*='first_name']").length) {
            firstName = $("input[id*='first_name']").val();
        }

        let lastName = "";
        if ($("input[id*='last_name']").length) {
            lastName = $("input[id*='last_name']").val();
        }

        let parentEmail = "";
        if ($("input[id*='parent_email']").length) {
            parentEmail = $("input[id*='parent_email']").val();
        }

        let cartAction   = getFullUrl(signupModule.CART.path,
            {
                id:id,
                authhash:authhash,
                couponCode: couponCode,
                creditCardNumber: creditCardNumber,
                firstName,
                lastName,
                parentEmail
            });
        $.get(cartAction,function(data){
            $(".class_start").html(data.class_start);
            $(".sub_total").html(data.formatted_sub_total);
            $(".surcharge").html(data.surcharge.formatted);
            $(".insurance").html(data.formatted_insurance);
            $(".discount").html(data.formatted_discount);
            $(".total-payable").html(data.formatted_total);
            $(".product-name").html(data.product);

            if (data.invalid_coupon_code_message !== undefined) {
                $(".coupon-error-message").removeClass('hidden');
            } else {
                $(".coupon-error-message:not(.hidden)").addClass('hidden');
            }

            if (data.coupon.length > 0) {
                $("#credit_card-apply").text("Applied");
                $("#credit_card-apply").prepend('<i class="icon-checkmark-circle text-white mr-5"></i> ')
            } else {
                $("#credit_card-apply").text("Apply");
            }

            if (data.accept_bookings === 0) {
               $('#form-data').hide();
               $('#form-error').html(data.booking_not_available_message);
               $('#form-error').show();
            }
            $("input[id*='class_start']").val(data.class_start);

            if (isInitLoad) {
                $("input[id*='class_date']").val(data.trial_day);
                isInitLoad = false;
            }

            $('.three-day-package').daterangepicker({
                minDate: new Date(),
                format: 'DD/MM/YYYY',
                singleDatePicker: true,
                locale: {
                    format: 'DD/MM/YYYY'
                },
                drops: "auto",
                autoUpdateInput: false,
                isInvalidDate: function (date) {
                    let isInvalidDate = false;

                    $.each(data.restricted_dates, function (index, restricted_date) {
                        let startDate = new Date(restricted_date.start);
                        let endDate = new Date(restricted_date.end);
                        let currentDate = new Date(date.format('Y/MM/DD'));

                        if (currentDate >= startDate && currentDate <= endDate) {
                            isInvalidDate = true;
                        }
                    });

                    return isInvalidDate || data.fully_class_dates.includes(date.format('DD/MM/Y'));
                }
            }).on('apply.daterangepicker', function (ev, picker) {
                $(this).val(picker.startDate.format('DD/MM/YYYY'));
            }).on('cancel.daterangepicker', function (ev, picker) {
                $(this).val('');
            });

            if (data.total <= 0) {
                $(".cc-info").slideUp(400, function (){
                    announceHeight();
                });
            } else {
                $(".cc-info").slideDown(400, function (){
                    announceHeight();
                });
            }

            $("input[id*='already_purchased_insurance']").val(data.already_purchased_insurance);
           return false;
        });
    };
  
    const formAfterPopulate = () => {
        $(".html-text").each(function(i,v){
            $("<div>" + $(v).val() + "</div>").insertBefore($(v));
        });
        announceHeight();
        paymentTermsSlide();
        waiverSlide();
        updateCart();

        $("#credit_card-apply").unbind('click').click(function (){
            updateCart();
            return false;
        });

        $("#credit_card-already_purchased_insurance").change(function (){
            updateCart();
            return true;
        });

        $("input[id*='card_number']").change(function (){
            updateCart();
            return true;
        });

        $("input[id*='first_name'], input[id*='last_name'], input[id*='parent_email']").change(function() {
            if ($("input[id*='first_name']").val().length > 0 && $("input[id*='last_name']").val().length > 0 && $("input[id*='parent_email']").val().length > 0) {
                updateCart();
            }
            return true;
        });

        let stripeCheckoutSessionId = null;

        $("#update").unbind('click').click(function(){
            $(".form_data").processForm({
                mode : "callback",
                callback: function(valid,response){
                    if (valid){
                        if (!response.redirect){
                            if (response.info.method == PaymentMethods.STRIPE) {
                                setStripePublicKey(loadStripe(response.info.public_key));
                                setClientSecret(response.info.client_secret);
                                stripeCheckoutSessionId = response.info.sessionId;
                                announceScroll();
                                $('#stripeCheckout').modal('show');

                                $('#stripeCheckout').unbind('hidden.bs.modal').on('hidden.bs.modal', function (e) {
                                    let cancelAction = getFullUrl(signupModule.CANCEL.path, {
                                        id: id,
                                        authhash: authhash,
                                        userAction: 'expire',
                                        session: stripeCheckoutSessionId
                                    });
                                    $.get(cancelAction, function (data) {
                                        return false;
                                    });
                                    return true;
                                });

                            }else if(response.info.method == PaymentMethods.SQUARE){
                                window.location.href = response.info.payment_link;
                            } else {
                                showUserMessageHTML ("",response.info.complete, 1,function(){
                                    if (response.info.redirect) {
                                        window.top.location.href = response.info.redirect;
                                    } else {
                                        window.location.reload();
                                    }
                                });
                            }
                            return false;
                        }else{
                            showUserMessageHTML("", 'Register successfully.', 1,function(){
                                window.parent.location.href = response.redirect;
                            });
                        }
                    }else{
                        window.setTimeout(function () {
                            announceHeight();
                            announceScroll();
                        }, 1000);
                        announceHeight();
                        announceScroll();
                        return false;
                    }
                }
            });
            return false;
        });
    };

    const {fetchFormData} = useFormInit({formAction, formAfterPopulate});

    useEffect( () => {
        if (student_id) {
            companyBranding();
        }else{
            $(".logo-block").hide();
        }
        $(window).resize(function(){
            announceHeight();
        });
    }, []);

    return (
        <>
            <div className="bg-white">
                <div className="text-center logo-block mt-5">
                    <div
                        className="display-block text-slate-300 pb-10 mb-10">
                        <img className="company-logo hide" alt="Logo" src={companyLogo}/>
                    </div>
                </div>
                <div className="text-center class-name-block mt-5">
                    <h3 className="text-uppercase product-name"></h3>
                </div>
                <div className="col-md-12">
                    <div>
                        <GlobalStyles
                            loadUrl={settingAction}
                        />
                        <Form
                            id="form-data"
                            action={formAction}
                            formClass='form_data generic_form'
                            encType='application/x-www-form-urlencoded'
                            jsonLoadAction={formDefinitionAction}
                            jsonLoadActionHandler={fetchFormData}
                        />

                        {clientSecret && <div class="modal fade" id="stripeCheckout" tabindex="-1" role="dialog"
                                              aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Stripe Checkout</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <div id="checkout">
                                            <EmbeddedCheckoutProvider
                                                stripe={stripePublicKey}
                                                options={{clientSecret}}
                                                key={clientSecret}
                                            >
                                                <EmbeddedCheckout/>
                                            </EmbeddedCheckoutProvider>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                    
                    <div id={'form-error'} className="alert alert-danger alert-styled-left alert-bordered"
                         style={{display: 'none'}}></div>
                </div>
                <div className="clearfix"/>
            </div>
        </>
    );
};

export default Container;
